import React, { Component } from "react";
import { Button, Panel } from "@allxsmith/bestax-bulma";

class AvailablePanel extends Component {
  state = {
    vehicles: this.props.vehicles || []
  };

  goToVehiclePage = id => {
    window.location.href = `/editvehicle/${id}`;
  };
  render() {
    return (
      <Panel className="scrollable-panel">
        <Panel.Heading>Vehicles Available</Panel.Heading>
        {this.props.vehicles.map(vehicle => (
          <Panel.Block key={vehicle.id}>
            <Button onClick={() => this.props.selectVehicle(vehicle)}>
              Select
            </Button>
            <div>
              {vehicle.registration} - {vehicle.make} - {vehicle.model} -{" "}
              {vehicle.type}
            </div>
            <Button
              className="is-pulled-right"
              onClick={() => this.goToVehiclePage(vehicle.id)}
            >
              Vehicle Page
            </Button>
          </Panel.Block>
        ))}
      </Panel>
    );
  }
}

export default AvailablePanel;
